// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3DjmR","buttons":"SendReceipts_buttons__3GoiB","email":"SendReceipts_email__EGo3J","bookApptTitle":"SendReceipts_bookApptTitle__A1WO-"};